import React from 'react'
import injectSheet from 'react-jss'
import compose from 'recompose/compose'
import pure from 'recompose/pure'
import CloseButton from 'aria-viewer/tour/components/buttons/closeButton'
import ShareButton from 'aria-viewer/tour/components/buttons/shareButton'
import LanguageButton from 'aria-viewer/tour/components/buttons/languageButton'
import Button from 'aria-viewer/tour/components/buttons/button'

const styleSheet = theme => ({
    header: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        padding: 16,
    },

    leftButton: {
        flex: 3,
    },

    rightButtons: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        paddingRight: 16,
    },

    langugageButton: {
        display: 'flex',
        alignItems: 'center',
        width: 75,
        height: 34,
        '& > span': {
            display: 'flex',
        },
    },

    arrowButton: {
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        paddingLeft: 8,
        '& #Shape': {
            fill: theme.palette.common.white,
        },
    },

    shareButton: {
        '& svg path': {
            fill: theme.palette.common.white,
        },

        '& div': {
            width: 18,
            height: 21,
        },
    },

    body: {
        color: theme.palette.common.white,
        padding: '0px 24px 48px',
    },

    title: {
        fontSize: 24,
        fontWeight: 500,
        marginBottom: 35,
    },

    description: {
        fontSize: 16,
        textAlign: 'left',
        overflowY: 'auto',
        '@media screen and (orientation: portrait)': {
            height: 488,
        },
        '@media screen and (orientation: landscape)': {
            height: '55vh',
        },
    },
})

const style = injectSheet(styleSheet)

const inlineStyle = {
    shareButton: {
        display: 'flex',
        width: 36,
        height: 36,
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 16,
    },

    arrowButton: {
        width: 8,
        height: 5,
    },
}

const MoreDescriptionDialog = ({ classes, className, title, description, language, onClose }) => (
    <div className={className}>
        <div className={classes.header}>
            <span className={classes.leftButton}>
                <CloseButton onClick={onClose} />
            </span>

            <span className={classes.rightButtons}>
                <LanguageButton className={classes.langugageButton} language={language}>
                    <Button
                        className={classes.arrowButton}
                        puresvg={true}
                        svgStyle={inlineStyle.arrowButton}
                        icon="arrowDropDown"
                    />
                </LanguageButton>

                <ShareButton style={inlineStyle.shareButton} className={classes.shareButton} />
            </span>
        </div>

        <div className={classes.body}>
            <div className={classes.title}>{title}</div>
            <div className={classes.description} dangerouslySetInnerHTML={{ __html: description }} />
        </div>
    </div>
)

export default compose(
    style,
    pure
)(MoreDescriptionDialog)
